import React, { createContext, useContext } from "react";

// Example: permissions = ["read:users", "edit:profile"]
export const PermissionContext = createContext([]);

export const PermissionProvider = ({ permissions, children }) => (
  <PermissionContext.Provider value={permissions}>
    {children}
  </PermissionContext.Provider>
);

export const usePermissions = () => useContext(PermissionContext);

export const HasPermissions = (permission) => {
  const permissions = usePermissions();

  if (typeof permission === 'function') {
    return permission(permissions);
  }
  else if (typeof permission === 'string') {
    return permissions.includes(permission);
  }
  else if (Array.isArray(permission)) {
    return permission.every(perm => permissions.includes(perm));
  }

  return false;
}

export default function PermissionGuard({ permission, children }) {
  const permissions = usePermissions();

  if (!permission) return children

  if (typeof permission === 'function') {
    if (permission(permissions)) {
      return children;
    }
  }
  else if (typeof permission === 'string') {
    if (permissions.includes(permission)) {
      return children;
    }
  }
  else if (Array.isArray(permission)) {
    const hasAllPermissions = permission.every(perm => permissions.includes(perm));
    if (hasAllPermissions) {
      return children;
    }
  }

  return null;
}